export const STROKE_DEFAULT = 2;

// Design breakpoints in desc order
const STROKE_BREAKPOINTS = [
  {
    breakpoint: 576,
    strokeWidth: 4,
  },
];

/**
 * Calculates the width of the stroke based on height and width.
 */
export const calculateStrokeWidth = (height: number, width: number) => {
  for (const { breakpoint, strokeWidth } of STROKE_BREAKPOINTS) {
    if (height >= breakpoint && width >= breakpoint) {
      return strokeWidth;
    }
  }

  return STROKE_DEFAULT;
};
